import React from 'react';
import { CheckIcon, XIcon, CircleXIcon, CircleCheckIcon } from 'lucide-react';
const problemas = ['Son difíciles de sostener', 'Te dejan sin ideas', 'Generan ansiedad', 'Terminás volviendo a lo mismo'];
const soluciones = ['Recetas fáciles y rápidas', 'Ingredientes simples del supermercado', 'Menos hinchazón, más energía', 'Forma sostenible y deliciosa'];
export function Solution() {
  return <section className="w-full bg-gradient-to-b from-mint-pale to-white px-6 py-20 sm:px-10" data-id="element-137" data-mp="qtylllj70a64">
      <div className="mx-auto max-w-5xl" data-id="element-138" data-mp="vuct92gvti3m">
        <h2 className="text-center font-heading text-3xl font-bold text-mint-dark sm:text-4xl" data-id="element-139" data-mp="vs03w48so5gj">
          La diferencia no está en hacer dieta
        </h2>
        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-10" data-id="element-140" data-mp="msmwri857syz">
          <div className="rounded-xl border-l-4 border-danger bg-red-50 p-8" data-id="element-141" data-mp="2c7tauvm60hcb">
            <h3 className="flex items-center gap-2 text-lg font-bold text-danger" data-id="element-142" data-mp="2h7fnb2u65tk2">
              <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-143" data-mp="2h5cxojwxi2fv" /> Dietas extremas
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-144" data-mp="6ynqshgfxqza">
              {problemas.map(item => <li key={item} className="flex items-start gap-2 text-sm text-gray-800" data-id="element-145" data-mp="2yww42nsmqph">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" aria-hidden="true" data-id="element-146" data-mp="gq201gy7255m" />
                  <span data-id="element-147" data-mp="bs0gkuwuw3tm">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="rounded-xl border-l-4 border-success bg-mint-deep p-8" data-id="element-148" data-mp="3k7sg32z59taw">
            <h3 className="flex items-center gap-2 text-lg font-bold text-mint-dark" data-id="element-149" data-mp="3g708ee5x7wgq">
              <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-150" data-mp="3u5q35n59pk1x" /> Alimentación antiinflamatoria práctica
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-151" data-mp="3p4sfiv1hnxt1">
              {soluciones.map(item => <li key={item} className="flex items-start gap-2 text-sm text-gray-800" data-id="element-152" data-mp="19dxq42t9cytf">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" aria-hidden="true" data-id="element-153" data-mp="14f328mgfok2g" />
                  <span data-id="element-154" data-mp="1cfskurl3t3w8">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}